import { GeneralPropsType } from "@/common/types";
import LoadingInside from "@/components/LoadingInside";
import { useGlobalData } from "@/contexts/GlobalData";
import clsx from "clsx";
import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";
interface DefaultPageLayoutPropsType extends GeneralPropsType {
  showBlurLoading?: boolean;
  id?: string;
  style?: React.CSSProperties;
}
function DefaultPageLayout({
  children,
  className,
  showBlurLoading,
  id,
  style
}: DefaultPageLayoutPropsType) {
  const pathname = usePathname();
  const {
    routeSetting
  } = useGlobalData();
  const router = useRouter();
  useEffect(() => {
    console.log("🚀🚀🚀🚀🚀🚀🚀 ~ DefaultPageLayout ~ pathname: ", pathname);
  }, []);
  useEffect(() => {
    try {
      if (!pathname || !routeSetting || !routeSetting[pathname] || !routeSetting[pathname]?.targetPath || !routeSetting[pathname]?.timeout) return;
      const tm = setTimeout(() => {
        router.push(routeSetting[pathname]?.targetPath);
        clearTimeout(tm);
      }, routeSetting[pathname]?.timeout);
    } catch (err) {
      console.log("🚀 ~ useEffect ~ err:", err);
    }
  }, [pathname, routeSetting]);
  return <div id={id} className={clsx("w-full px-4 pt-4 pb-[140px] relative", className)} style={style} data-sentry-component="DefaultPageLayout" data-sentry-source-file="index.tsx">
            {children}
            {showBlurLoading && <div className={clsx("fixed inset-0 bg-black/[0.3] backdrop-blur-[2px] flex items-center justify-center z-[9999]")}>
                    <LoadingInside />
                </div>}
        </div>;
}
export default DefaultPageLayout;